import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../../services";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { Title } from '@angular/platform-browser';
import { UtilService } from 'src/app/modules/shared/services';

enum ResetPage {
  RESET_PASSWORD_GET_EMAIL = 'RESET_PASSWORD_GET_EMAIL',  // USER has asked to reset password and needs to enter email
  CODE = 'CODE',   // USER has received code and needs to enter it
  NEW_PASSOWORD = 'NEW_PASSWORD',  // USER is entering new password
  NEW_PASSWORD_AFTER_CHALLENGE = 'NEW_PASSWORD_AFTER_CHALLENGE' // ADMIN has forced user to reset password after login
}

enum ResetAction {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
}

@Component({
  selector: 'app-auth-reset',
  templateUrl: './auth-reset.component.html',
  styleUrls: ['./auth-reset.component.scss']
})
export class AuthResetComponent implements OnInit {
  code: string = '';
  public curPageEnum = ResetPage;
  public resetActionEnum = ResetAction;
  
  
  public curPage : ResetPage = ResetPage.RESET_PASSWORD_GET_EMAIL;
  public resetAction : ResetAction = ResetAction.FORGOT_PASSWORD;
  showPassword: boolean = false;

  userEmail: string | null = null;

  emailFormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  passwordResetFormGroup = new FormGroup({
    password: new FormControl('', [Validators.required, this.authService.passwordPatternValidator]),
  });

  constructor(
    private title: Title,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private util: UtilService,
    private toastrService: ToastrService) {
  }

  ngOnInit() {
    // set page title
    this.title.setTitle('Rondeivu | Reset Password');
    var action = this.activatedRoute.snapshot.queryParamMap.get('action');

    if (action === 'set-new-password') {
      // This is when the user has requested a password reset via "Forgot Password"
      this.userEmail = this.authService.getUserEmail();
      
      if (!this.userEmail) {
        console.error("No user email found for forced password reset");
        this.toastrService.error('No user email found for password reset. Please log in again.', 'Error');
        this.authService.navigateToLogin();
        return;
      }

      this.emailFormGroup.get('email')?.setValue(this.userEmail);

      this.curPage = ResetPage.NEW_PASSWORD_AFTER_CHALLENGE;
      this.resetAction = ResetAction.FORGOT_PASSWORD;
    } 
    else if (action === 'new-password-required') {
      // This is when ADMIN has forced the user to reset their password after successful login
      this.userEmail = this.authService.getUserEmail();
      
      if (!this.userEmail) {
        console.error("No user email found for forced password reset");
        this.toastrService.error('No user email found for password reset. Please log in again.', 'Error');
        this.authService.navigateToLogin();
        return;
      }


      this.emailFormGroup.get('email')?.setValue(this.userEmail);

      this.curPage = ResetPage.CODE;
      this.resetAction = ResetAction.NEW_PASSWORD_REQUIRED;

      this.sendCode();
    } 
  }

  sendCode(): void {
    console.log('Requesting password reset for email:', this.userEmail);

    if (this.userEmail === null || this.userEmail.trim() === '') {
      this.userEmail = this.emailFormGroup.get('email')?.value || '';
    }

    if (this.userEmail === null || this.userEmail.trim() === '') {
      console.error('Valid email is required to request password reset');
      this.toastrService.error('Please enter a valid email address.', 'Error');
      return;
    }

    try {
    //  this.util.loader();
     this.authService.ForgotPassword(this.userEmail).subscribe({
      next: (res: any) => {
        this.curPage = ResetPage.CODE;
      },
      error: (error: any) => {
        console.error('Error requesting password reset', error);
      }
    });
    } 
    catch (error: any) {
      console.error('Unexpected error during password reset request', error);
      this.toastrService.error(error.message || 'Unexpected error occurred.', 'Error');
    }
  }

  confirmEmailCode(code: string): void {
    this.code = code;
    this.curPage = ResetPage.NEW_PASSOWORD;
  }

  setNewPassword(): void {
    console.log('Resetting password for email:', this.userEmail, 'with code:', this.code);
    var password: string = this.passwordResetFormGroup.get('password')?.value || '';
    if (!this.userEmail || this.userEmail.trim() === '') {
      console.error('User email is required for resetting password');
      this.toastrService.error('Please enter a valid email address.', 'Error');
      return;
    }

    if (!password) {
      console.error('Password is required for resetting password');
      this.toastrService.error('Please enter a valid password.', 'Error');
      return;
    }


    this.util.loader();
    try {
      this.authService.ConfirmForgotPassword(this.userEmail, this.code, password).subscribe({
        next: () => {  
          console.log('Password reset successful for', this.userEmail);
          this.util.loader(false);
          this.authService.navigateToLogin();
        },
        error: (error) => {
          console.error('Error resetting password', error);
          this.toastrService.error('Error resetting password. Please try again later.', 'Error');

          // reset to initial state
          this.code = "";
          this.curPage = ResetPage.RESET_PASSWORD_GET_EMAIL;
          this.util.loader(false);
        }
      });

    } catch (error: any) {
      console.error('Unexpected error during password reset', error);

      // reset to initial state
      this.code = "";
      this.curPage = ResetPage.RESET_PASSWORD_GET_EMAIL;
      this.util.loader(false);
    }
  }

  setNewPasswordAfterChallenge(): void {
    console.log('Resetting password for email:',  this.userEmail); 
    var password: string | null | undefined = this.passwordResetFormGroup.get('password')?.value;

    if (!password) {
      console.error('Password is required for resetting password');
      this.toastrService.error('Please enter a valid password.', 'Error');
      return;
    }

    // console.log("password is ", password);

    // this.util.loader();
    this.authService.SetNewPasswordAfterChallenge(password).subscribe({
      next: () => {console.log('Password reset successful for', this.userEmail);},
      error: (error) => {
        console.error('Error resetting password', error);
        this.toastrService.error('Error resetting password. Please try again later.', 'Error');
      }
    });
  }
}
